import React from "react";
import { Link } from "@quintype/components";
import { string } from "prop-types";

import { Twitter, Facebook } from "../../atoms/icons/StoryPageIcons";

import "./socialShareTemplate.m.css";

const SocialShareTemplate = props => (
  <span styleName="icons" className="icons">
    <Link href={props.fbUrl} target="_blank" rel="noopener noreferrer">
      <Facebook color1={props.color1} color2={props.color2} />
    </Link>
    <Link href={props.twitterUrl} target="_blank" rel="noopener noreferrer">
      <Twitter color1={props.color1} color2={props.color2} />
    </Link>
  </span>
);

SocialShareTemplate.propTypes = {
  twitterUrl: string,
  fbUrl: string,
  color1: string,
  color2: string
};

export default SocialShareTemplate;
